
<template>
  <div class="quick-links-widget">
    <template v-for="item in linksVisible">
      <div
        v-if="renderComponent"
        :key="item.id"
        class="fast-link"
      >
        <div
          v-if="item.icon"
          class="fast-link__icon"
        >
          <svg-loader
            :id="item.id"
            class="icon-quick-links"
            :src="'/static/images/icon-dashboard-' + item.icon + '.svg'"
          />
        </div>
        <div
          class="fast-link__item"
          :class="{'fast-link__description--bigger': item.sizeBig} "
          @click="go(item.action)"
        >
          <p :id="item.id">
            {{ item.text }}
          </p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { DASHBOARD_FAST_LINKS, eventBus } from '@/api/eventbus'

export default {
  name: 'QuickLinks',
  props: {
    content: {
      icon: {
        type: String
      },
      text: {
        type: String
      },
      sizeBig: {
        type: Boolean,
        default: false
      }
    }
  },
  data () {
    return {
      items: [],
      renderComponent: true
    }
  },
  computed: {
    linksVisible: function () {
      return this.content.items.filter(elem => elem.visible)
    }
  },
  beforeDestroy () {
    eventBus.$off(DASHBOARD_FAST_LINKS)
  },
  methods: {
    go (action) {
      eventBus.$emit(DASHBOARD_FAST_LINKS, action)
    }
  }
}
</script>
<style lang="scss" scoped>
.quick-links-widget {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin-bottom: 34px;

  .fast-link {
    display: flex;
    width: 100%;
    text-align: left;
    color: #7a7a7a;
    cursor: pointer;
    margin-top: 0.3em;
    align-items: center;

    &__icon {
      width: 10%;
      
      .icon-quick-links {
        width: 16px !important;
        height: 16px !important;
        min-height: 16px;
        min-width: 16px;
        margin: auto;
      }
    }

    &__item {
      flex-shrink: 1;
      margin-top: 5px;

      p {
        font-family: 'Exo 2', sans-serif;
        font-weight: 500;
        font-size: 14px;
        text-align: left;
        text-transform: math-auto;
        color: #7a7a7a;

        &:hover {
          color: #7f1a54;
        }
      }
    }
  }
}
</style>
